import {getDate} from "../util";

export const calculateDateRange = (list: any[]) =>{
  let minFrom = 999999
  let maxTo = 0
  list.forEach((item) => {
    if (item?.yearFrom < minFrom) minFrom = item?.yearFrom
    if (item?.yearTo > maxTo) maxTo = item?.yearTo
  })
  return getDate(minFrom, maxTo)
}